import Model from 'models/Model';
import ProductEnhancement from 'models/productManagement/productEnhancement/Model.ProductEnhancement';
import ContractConsent from '../contractConsent/Model.ContractConsent';

export default class ContractConsentEnhancement
  extends Model<Model.IContractConsentEnhancement>({ icon: 'if-login' })
  implements Model.Instance<Model.IContractConsentEnhancement>
{
  id: number;
  priceCAD: number;
  originalPriceCAD: number;
  discountPriceCAD: number;
  distributorPriceCAD: number;
  pricingDistributions?: Utils.PricingDistribution;
  distributorDistributions?: Utils.PricingDistribution;
  productEnhancementId?: number;
  productEnhancement?: ProductEnhancement;
  contractConsentId?: number;
  contractConsent?: ContractConsent;

  constructor(
    data: Partial<Model.IContractConsentEnhancement> | Utils.FormData<Model.IContractConsentEnhancement>,
    language?: Locale.Languages
  ) {
    super(
      {
        productEnhancement: ProductEnhancement,
        contractConsent: ContractConsent,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.productEnhancementId,
      title: this.productEnhancement?.name || this.productEnhancementId.toString(),
    };
  }
}
